import { connect } from 'react-redux';
import AgencySignup from './agencySignup';
import {
    getAgencySignupErrorCode,
    getAgencySignupStatus,
    getAgencySignupIsLoading,
    getAgencySignupEmailSent,
    getAgencyNameAvailable,
} from './selector';
import {
    submitAgencySignupForm,
    resendAgencyConfirmationEmail,
    checkAgencyName,
} from './actions';

const mapStateToProps = state => ({
    status: getAgencySignupStatus(state),
    errorCode: getAgencySignupErrorCode(state),
    isLoading: getAgencySignupIsLoading(state),
    emailSent: getAgencySignupEmailSent(state),
    nameAvailable: getAgencyNameAvailable(state),
});

const mapDispatchToProps = dispatch => ({
    onSubmitClick: data => {
        dispatch(submitAgencySignupForm(data));
    },
    onResendClick: email => {
        dispatch(resendAgencyConfirmationEmail(email));
    },
    onCheckAgencyName: (agencyName, email) => {
        dispatch(checkAgencyName(agencyName, email));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencySignup);
